import React from "react";
import { Link } from "react-router-dom";

type Props = {
    label: string;
};

const BackButton: React.FC<Props> = ({ label }) => (
    <Link to={"/annonces"} className="inline-flex items-center gap-3 mb-6 group">
        <span className="w-10 h-10 bg-white border border-[#f1f5f9] rounded-[14px] drop-shadow-[0px_1px_1.5px_rgba(0,0,0,0.1),0px_1px_1px_rgba(0,0,0,0.1)] flex items-center justify-center shrink-0 group-hover:bg-[#f8fafc] transition-colors">
            <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#5a607c"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                <polyline points="15 18 9 12 15 6" />
            </svg>
        </span>
        <span className="text-[16px] font-bold text-[#5a607c]">{label}</span>
    </Link>
);

export default BackButton;
